/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuDisplayPrefsSelect_filters$ref = any;
type SbSharedRefineMenuFilters_filters$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespRefineMenu_filters$ref: FragmentReference;
export type SbRespRefineMenu_filters = $ReadOnlyArray<{|
  +$fragmentRefs: SbSharedRefineMenuFilters_filters$ref & SbSharedRefineMenuDisplayPrefsSelect_filters$ref,
  +$refType: SbRespRefineMenu_filters$ref,
|}>;
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespRefineMenu_filters",
  "type": "SearchBrowseFilter",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilters_filters",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuDisplayPrefsSelect_filters",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'fbe4a3afa9de14b2bf5167e3b6714133';
module.exports = node;
